import { hideVisually } from "polished";
import React from "react";
import styled from "styled-components";
import Dialog from "./Dialog";

const CloseLabel = styled.span`
  ${hideVisually}
`;

const StyledHeader = styled.div<IStyledHeaderProps>`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.space[3]};
`;

const DialogHeading = styled.h2`
  margin-top: ${({ theme }) => theme.space[3]};
  margin-bottom: 0;
  padding: 0 ${({ theme }) => theme.space[4]};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[5]};
  text-align: left;
`;

interface IDialogHeaderProps {
  children: React.ReactNode;
  closeDialog: () => void;
}

interface IStyledHeaderProps {
  variant?: "light" | undefined;
}

type DialogHeaderProps = IDialogHeaderProps & IStyledHeaderProps;

const DialogHeader: React.FC<DialogHeaderProps> = ({
  children,
  variant,
  closeDialog,
}) => (
  <StyledHeader variant={variant}>
    <DialogHeading id="ism-dialog-title">{children}</DialogHeading>
    <Dialog.Header closeDialog={closeDialog}>
      <CloseLabel>close</CloseLabel>
    </Dialog.Header>
  </StyledHeader>
);

export default DialogHeader;
